import { CONTENT } from '../../appConfig';

const ABOUT_ME = CONTENT.aboutMe;
const BLOG = CONTENT.blog;
const CONSULT = CONTENT.consult;

export {
  ABOUT_ME,
  BLOG,
  CONSULT
};
